import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classNames from 'classnames';
import Badge from 'components/Badge';
import { isInternalLink } from 'helpers/ContentHelper';
import { TileImage, TileTitle, Detail } from '../../../components';
import { titleProcessor } from '../../../helpers/processorHelper';
import Style from '../../../Styles/SearchTile.module.scss';

const SearchTile = ({
  altText,
  badge,
  hoverImage,
  image,
  link,
  onTileClick,
  startDate,
  theme,
  titleLink,
  isTubi,
  ...rest
}) => {
  const tubiLogo = window?.ExternalConfig?.tubiLogo;
  const titleOptions = {
    ...titleProcessor(rest),
    link: titleLink || link,
    onClick: onTileClick,
    Style,
  };

  const content = (
    <>
      {isTubi && <img className={Style.tubiBadge} src={tubiLogo} alt="tubi badge" />}
      <TileImage image={image || hoverImage} altText={altText} theme={Style} />
      <Badge theme={Style} badge={badge} startDate={startDate} />
    </>
  );

  const linkClasses = [Style.imageContainer, Style.maintainRatioContainer, isTubi && Style.tubi];

  return (
    <div className={classNames(theme.tile, Style.tile)}>
      {isInternalLink(titleLink || link) ? (
        <Link to={link || titleLink} onClick={onTileClick} className={classNames(linkClasses)}>
          {content}
        </Link>
      ) : (
        <a href={link || titleLink} onClick={onTileClick} className={classNames(linkClasses)}>
          {content}
        </a>
      )}
      <Detail theme={Style}>
        <div className={Style.info}>
          <TileTitle {...titleOptions} />
        </div>
      </Detail>
    </div>
  );
};

export default SearchTile;

SearchTile.propTypes = {
  altText: PropTypes.string,
  badge: PropTypes.string,
  hoverImage: PropTypes.string,
  image: PropTypes.string,
  isTubi: PropTypes.bool,
  link: PropTypes.string,
  onTileClick: PropTypes.func,
  startDate: PropTypes.string,
  theme: PropTypes.shape({}).isRequired,
  titleLink: PropTypes.string,
};

SearchTile.defaultProps = {
  altText: null,
  badge: null,
  hoverImage: null,
  image: null,
  link: null,
  startDate: null,
  titleLink: null,
};
